<template>
    <section id="classPage" class="class-page" style="padding:15px;">
       	<class-page-header :details="details" :current-section="parseInt(sectionId)" :course="course" :menu="menu" :is-class-item-page="true"></class-page-header>
        <div class="back-link">
			<a style="cursor:pointer" @click="$router.go(-1)">
				<i class="fas fa-caret-left" aria-hidden="true"></i>{{ $t('MAIN_CONTENT.commonContent.goBack') }}
			</a>
		</div>
		<div class="class-page-body">
						<h2>{{subpage.REPORT_NAME}}</h2>
            <div v-html="subpage.REPORT_DESCRIPTION"></div>
        </div>
        
        <class-page-footer :course="course" :menu="menu" :current-section="parseInt(sectionId)" :is-class-item-page="true"/>
        <div class="back-link">
			<a style="cursor:pointer" @click="$router.go(-1)">
				<i class="fas fa-caret-left" aria-hidden="true"></i>{{ $t('MAIN_CONTENT.commonContent.goBack') }}
			</a>
		</div>
    </section>
</template>
<script>

import { mapGetters } from "vuex";
import ClassPageHeader from "./Header.vue";
import ClassPageFooter from "./Footer.vue";

import ClassPageDetailsResource from '../../api/ClassPageDetails';
import ClassPageMenuResource from '../../api/ClassPageMenu';
import ClassPageSectionResource from '../../api/ClassPageSection';
import ClassPageSubpageResource from '../../api/ClassPageSubpage';
import CoursesResource from '../../api/Courses';

/**
 * @vue-prop {Number} [subpage=1] - Current subpage.
 * @vue-prop {Number} [section=0] - Current class section which is parent of the subpage.
 * @vue-computed {String} subPageContent - The subpage's content (html).
 * @vue-computed {String} subPageTitle - The subpage's title.
 */
export default {
	components: {
			ClassPageHeader,
			ClassPageFooter
	},
	props: {
		section: { 
				type    : Number,
				default : 0
		},
	},
	data() {
		return {
			sectionData: {},
			menu: [],
			details: {},
			course: {},
			subpage: {},
		};
	},
	computed: {
		...mapGetters(['selectedStudent', 'roleRules']),
		sectionId() {
			return this.$route.params.folderId ? this.$route.params.folderId : 0;
		}
	},
	created() {
		this.$store.commit('setUseHeader', false);
		//this.fetchSection();
		this.fetchMenu();
		this.fetchDetails();
		this.fetchCourse();
		this.fetchSubpage();
  },
	methods: {
		goToClassPage() {
			let params = this.$route.params;
			
			this.$router.push({
				name: 'ClassPageHome',
				params: {
					courseSectionGUID: this.$route.params.courseSectionGUID
				},
			});
		},
		fetchSubpage() {
			let type = '';
			if( this.$route.name === 'ClassPageSubpage' ){
				type = 'course';
			} else if( this.$route.name === 'ClassPageSectionSubpage' ){
				type = 'course';
			} else if ( this.$route.name === 'ClassPageGroupSubpage' ) {
				type = 'group';
			} else if ( this.$route.name === 'ClassPageStudentSubpage' ) {
				type = 'student';
			}
			const ClassPageSubpage = new ClassPageSubpageResource({
				routeParams: {
					courseSectionGuid: this.$route.params.courseSectionGUID,
					lineNo: this.$route.params.lineNo,
				},
				query: {
					student_rid: this.selectedStudent.STUDENT_RID,
				},
				type: type,
			});

			ClassPageSubpage.get().then(() => {
				this.subpage = ClassPageSubpage.getResponseData();
			});
		},
		fetchSection(){
			const ClassPageSection = new ClassPageSectionResource({
				routeParams: {
					courseSectionGuid: this.$route.params.courseSectionGUID,
					folderId: this.$route.params.folderId,
				},
				query: {
					student_rid: this.selectedStudent.STUDENT_RID,
				}
			});

			ClassPageSection.get().then(() => {
				this.sectionData = ClassPageSection.getResponseData();
			});
		},
		fetchMenu(){
			const ClassPageMenu = new ClassPageMenuResource({
				routeParams: {
					courseSectionGuid: this.$route.params.courseSectionGUID,
				},
				query: {
					student_rid: this.selectedStudent.STUDENT_RID,
				},
			});

			ClassPageMenu.get().then(()=>{
				this.menu = ClassPageMenu.getResponseData();
			});
		},
		fetchDetails(){
			const ClassPageDetails = new ClassPageDetailsResource({
				routeParams: {
					courseSectionGuid: this.$route.params.courseSectionGUID,
				},
				query: {
					student_rid: this.selectedStudent.STUDENT_RID,
				},
			});

			ClassPageDetails.get().then(()=>{
				this.details = ClassPageDetails.getResponseData();
			});
		},
		fetchCourse(){
			const Course = new CoursesResource({
				routeParams: {
					courseSectionGuid: this.$route.params.courseSectionGUID,
				},
				query: {
					student_rid: this.selectedStudent.STUDENT_RID,
				},
			});

			Course.get().then(()=>{
				this.course = Course.getResponseData();
			});
		}
	}
};
</script>
